import { InjectionToken } from "@angular/core";

import { NgrxUtilsConfig } from "./model";

export const NGRX_UTILS_CONFIG = new InjectionToken<NgrxUtilsConfig>("ngrxUtilsConfig");

/**
 * @internal
 */
export const _NGRX_UTILS_CONFIG = new InjectionToken<NgrxUtilsConfig | (() => NgrxUtilsConfig)>("_ngrxUtilsConfig");
